import axiosInstance from "auth/FetchInterceptor";
import {
  SET_DEFAULT_BANK_ACCOUNT_API,
  UPDATE_BANK_ACCOUNT_API,
  CREATE_BANK_ACCOUNT_API,
  GET_ALL_BANK_ACCOUNT,
  BANK_ACCOUNT_API,
  GET_BANKS,
} from "constants/ApiConstant";
const BankAccountService = {};

BankAccountService.getAllBankAccount = function (data) {
  return axiosInstance.post(GET_ALL_BANK_ACCOUNT, data);
};
BankAccountService.getBankAccountById = function (id) {
  return axiosInstance.get(`${BANK_ACCOUNT_API}/${id}`, null);
};
BankAccountService.getAllBanks = function () {
  return axiosInstance.get(GET_BANKS, null);
};
BankAccountService.createBankAccount = function (data) {
  return axiosInstance.post(CREATE_BANK_ACCOUNT_API, data);
};
BankAccountService.updateBankAccount = function (data) {
  return axiosInstance.put(UPDATE_BANK_ACCOUNT_API, data);
};
BankAccountService.deleteBankAccount = function (id) {
  return axiosInstance.delete(`${BANK_ACCOUNT_API}/${id}`, null);
};
BankAccountService.setDefaultBankAccount = function (data) {
  return axiosInstance.put(SET_DEFAULT_BANK_ACCOUNT_API, data);
};

export default BankAccountService;
